var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isDuoInternetAndMobile
        ? [
            _c("div", { staticClass: "col-12 bg-gray2" }, [
              _c("div", { staticClass: "h4 mb-0" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card",
          class: _vm.isDuoInternetAndMobile ? "mb-3" : "my-1",
        },
        [
          _c("div", [
            _vm.showGlobalDiscountsLabel && _vm.totalDiscountsLabel
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-12 text-center banner-wrapper py-1 d-flex align-items-start justify-content-center ob1-tag bg-greige",
                  },
                  [
                    _c("span", {
                      staticClass:
                        "icon text-primary icon-phone-fund-euro font-size-20",
                      staticStyle: { "margin-right": "5px" },
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("strong", {
                      domProps: {
                        textContent: _vm._s(_vm.totalDiscountsLabel),
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.isDuoInternetAndMobile ? "card-body p-1" : "" },
            [
              _vm.internetDto
                ? _vm._l(_vm.internetDto.items, function (item, index) {
                    return _c("CartPageItem", {
                      key: item.offerName
                        ? item.offerName
                        : "cart-page-internet-item-" + index,
                      attrs: {
                        dto: item,
                        "cross-sell-content": _vm.crossSellContent,
                        "is-internet-and-mobile-pack":
                          _vm.isDuoInternetAndMobile,
                      },
                      on: {
                        "remove-item-from-cart-in-progress": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-in-progress",
                            $event
                          )
                        },
                        "remove-item-from-cart-success": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-success",
                            $event
                          )
                        },
                        "remove-item-from-cart-error": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-error",
                            $event
                          )
                        },
                      },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasCrossSellOffers && _vm.crossSellContent.showNewDesign
                ? [
                    _c("div", { staticClass: "row px-2 pb-1" }, [
                      _c("div", { staticClass: "col-12 bg-greige" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-lg-7 py-1" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-greige d-flex align-items-center",
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "alert-icon text-primary font-size-28 me-1",
                                  class: _vm.crossSellContent.pushIcon,
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "ob1-alert-title fw-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.crossSellContent.pushTitle)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "ob1-alert-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.crossSellContent.pushSubTitleText
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-lg-5 d-flex justify-content-lg-end text-lg-end ps-4 ps-lg-0",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "ob1-link-arrow",
                                  attrs: {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target":
                                      "#" +
                                      _vm.crossSellContent.modalOffersLink.url,
                                    type: "button",
                                    "aria-label":
                                      _vm.crossSellContent.modalOffersLink
                                        .label,
                                    "data-test-id": "btn-popin-detail-forfait",
                                    "data-oevent-category":
                                      _vm.crossSellContent.modalOffersLink.tms
                                        .category,
                                    "data-oevent-action":
                                      _vm.crossSellContent.modalOffersLink.tms
                                        .action,
                                    "data-oevent-label":
                                      _vm.crossSellContent.modalOffersLink.tms
                                        .label,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.crossSellContent.modalOffersLink
                                          .label
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isDuoInternetAndMobile
                ? _c("card-content-separator", {
                    attrs: { "icon-class": "icon-Add text-primary" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileDto
                ? _vm._l(_vm.mobileDto.items, function (item, index) {
                    return _c("CartPageItem", {
                      key: item.offerName
                        ? item.offerName
                        : "cart-page-mobile-item-" + index,
                      attrs: {
                        dto: item,
                        "cross-sell-content": null,
                        "is-internet-and-mobile-pack":
                          _vm.isDuoInternetAndMobile,
                      },
                      on: {
                        "remove-item-from-cart-in-progress": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-in-progress",
                            $event
                          )
                        },
                        "remove-item-from-cart-success": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-success",
                            $event
                          )
                        },
                        "remove-item-from-cart-error": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-error",
                            $event
                          )
                        },
                      },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowDeviceInPack && _vm.deviceDto
                ? _vm._l(_vm.deviceDto.items, function (item, index) {
                    return _c("CartPageItem", {
                      key: item.offerName
                        ? item.offerName
                        : "cart-page-device-item-" + index,
                      attrs: {
                        dto: item,
                        "is-internet-and-mobile-pack":
                          _vm.isDuoInternetAndMobile,
                      },
                      on: {
                        "remove-item-from-cart-in-progress": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-in-progress",
                            $event
                          )
                        },
                        "remove-item-from-cart-success": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-success",
                            $event
                          )
                        },
                        "remove-item-from-cart-error": function ($event) {
                          return _vm.$emit(
                            "remove-item-from-cart-error",
                            $event
                          )
                        },
                      },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.promotionContent
                ? _c("CartPageAdditionalAcquisition", {
                    attrs: { dto: _vm.promotionContent },
                    on: {
                      "sponsor-success": function ($event) {
                        return _vm.$emit("sponsor-success", $event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.hasCrossSellOffers && !_vm.crossSellContent.showNewDesign
        ? _vm._l(_vm.internetDto.items, function (item, index) {
            return _c(
              "div",
              {
                key: "cart-page-cross-sell-item-" + index,
                staticClass:
                  "d-flex flex-column justify-content-center align-items-center pt-1",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "ob1-link no-decoration",
                    attrs: { href: "#cross-sell-content" },
                  },
                  [
                    _c("span", {
                      staticClass: "ob1-link-icon-text",
                      domProps: {
                        textContent: _vm._s(item.crossSellLinkLabel),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "icon icon-arrow-down d-block text-center pt-custom",
                    }),
                  ]
                ),
              ]
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }